import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { isOmbudsman, OMBUDSMAN_REDIRECT_PATH } from '../utils/rbac';

const OmbudsmanRoute: React.FC = () => {
  const { user, loading } = useAuth();
  
  // Loading state
  if (loading) {
    return <div>Loading...</div>;
  }
  
  // Check if user is ombudsman
  if (!isOmbudsman(user)) return <Navigate to={OMBUDSMAN_REDIRECT_PATH} replace />;
  
  return <Outlet />;
};

export default OmbudsmanRoute;
